import axios from 'axios'

export default async function getModelMember(path, Model, query = {}) {
  return axios
    .get(`${path}.json`, { params: { query } })
    .then(({ data }) => {
      const instance = new Model(data[Model.singularCamelName]);
      return { ...data, [Model.singularCamelName]: instance };
    })
    .catch((e) => {
      return { error: true };
    });
}
